/** @jsxImportSource @emotion/react */
import { useState } from 'react'
import { ManageAccounts } from '@mui/icons-material'
import { Box, Typography, useTheme } from '@mui/material'

import { Button } from '@app/components/Atoms/Button'
import { Autocomplete } from '@app/components/Atoms/Autocomplete/Autocomplete'

import { useChangeTempRole } from '../hooks/useChangeTempRole'
import { UserCustomRole, UserRole } from '@app/types'
import { handleRolesCascade } from '../utils/Admin.utils'
import { SELECTABLE_ROLES, USER_ROLES_LABELS_MAP } from '@app/app-constants'

import {
  formTitleStyle,
  formDescriptionStyle,
  temporaryRoleWrapper,
  autocompleteWrapper,
  autocompleteCustom,
} from '../styles/Admin.styles'

export const TempRolesSelector = ({
  customRoles,
}: {
  customRoles: UserCustomRole[] | undefined
}) => {
  const theme = useTheme()
  const [userTempRole, setUserTempRole] = useState<string[]>([])
  const { setTempRole } = useChangeTempRole()

  return (
    <Box css={temporaryRoleWrapper}>
      <Typography
        id="manage-user-drawer-title"
        variant="h5"
        css={formTitleStyle(theme.palette.primary.dark)}
      >
        View Role Permissions
      </Typography>
      <Typography variant="body1" css={formDescriptionStyle(theme.palette.primary.dark)}>
        Change roles temporarily to test out permissions for a specific role. Reset back to your
        original roles by clicking the reset button on the toast.
      </Typography>
      <Box css={autocompleteWrapper}>
        <Autocomplete
          value={userTempRole}
          options={[
            ...SELECTABLE_ROLES,
            ...(customRoles ? customRoles.map((role) => role.name.toLowerCase() as UserRole) : []),
          ]}
          onChange={(_, value) => setUserTempRole(handleRolesCascade(value) as UserRole[])}
          labelsMap={{
            ...USER_ROLES_LABELS_MAP,
            ...(customRoles
              ? Object.fromEntries(
                  customRoles.map((role) => [role.name.toLowerCase(), role.description]),
                )
              : {}),
          }}
          customStyles={autocompleteCustom}
          fixedOptions={['viewer']}
        />
        <Button
          variant="contained"
          onClick={() => {
            setTempRole(userTempRole)
          }}
          startIcon={<ManageAccounts />}
        >
          Save
        </Button>
      </Box>
    </Box>
  )
}
